import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {InsolesProfileRepository} from "./impl/service/ngrx/insolesProfile.repository";
import {InsolesProfileDataService} from "./impl/service/ngrx/insolesProfile.data.service";
import {errorMessages} from "../../core/error/errorMessages";

@NgModule()
export class InsolesProfileModule {
     constructor(entityDataService: EntityDataService,
                 entityServices: EntityServices,
                 repository: InsolesProfileRepository,
                 dataService: InsolesProfileDataService,
    ) {

        entityDataService.registerServices({
            InsolesProfile: dataService,
        });

        entityServices.registerEntityCollectionServices({
            Insoles: repository,
        });

        errorMessages.set("INSOLES_PROFILE_SAVE_NAME_ALREADY_EXISTS", 'Un profil avec ce nom existe déjà.');
    }
}
